import { render } from "./ExpirationReminder.vue?vue&type=template&id=1b8cb1ef&scoped=true"
import script from "./ExpirationReminder.vue?vue&type=script&lang=js"
export * from "./ExpirationReminder.vue?vue&type=script&lang=js"

import "./ExpirationReminder.vue?vue&type=style&index=0&id=1b8cb1ef&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8cb1ef"]])

export default __exports__